module.exports = __webpack_public_path__ + "static/z6g-bee4afee186703a82f91bcb42f0f67be.jpg";